import { useContext } from "react";
import ScreenReaderAlertContext from "./context";

export const useAlertScreenReader = () => {
  const context = useContext(ScreenReaderAlertContext);

  if (!context) {
    throw new Error(
      "alertScreenReader must be used within a ScreenReaderAlertContext.Provider"
    );
  }

  return context;
};
